"use client";

import { useSnapshot } from "valtio";
import { AccountState } from "../../stores/accountStore";
export function useAccountStates() {
  const {
    tsStates
  } = useSnapshot(AccountState);
  return tsStates;
}